// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__BPS7a","containerComponents":"EmptyList_containerComponents__KNXF4","errormsg":"EmptyList_errormsg__gJKO7","footer":"EmptyList_footer__cQ9Bm"};